<template lang="pug">
    v-container(fluid data-test="candidates")
        portal(to='toolbar') 
          v-toolbar-title Candidates
            b(v-if="getTitleLocation()") : {{ courseLocations | normalizeListWithComma }}
        create
        .d-flex
          div(:class="{'filters-open': showingFilters}").full-width
            portal-target(name="candidate-filters-chips")
            transition(name="component-fade")
              router-view(ref="list" @candidatesCountsChanged="setCandidatesCount")
            log
              template(v-slot:action="log")
                span
                  v-btn( 
                    color="primary" fab @click="log.loadLogs" data-test="log-btn" 
                    :class="{'filters-hide': showingFilters}"
                  ).btn-floating
                    v-icon(color="white") mdi-post

                  filters( 
                    :showing.sync="showingFilters" 
                    :candidatesCount="candidatesCount"
                    @update:showing="log.onlyHide"
                    @filterChanged="loadList" 
                    @clickedOnLocationTab="goToLocation" 
                    @refreshClicked="loadList"
                    data-test="filters" 
                    ref="filters"
                  ) 
</template>

<script>
import {mapActions, mapGetters} from "vuex"

import { getMultipleQueryValue } from "@/util"
import {LOG_PAGE, CRM_PERMS} from "@/util/const"
import {FILTERS_ARGS} from "./core/candidates-const"
import CandidatesSvc from "@/app/admin/modules/candidates/core/candidates-service"
import PaginationMixin from "@/mixins/pagination.mixin"
import Filters from "./components/CandidatesFilters.vue"
import CandidateLogModel from "./core/models/candidatesLogModel"
import Logs from "@/app/admin/components/Log.vue"
import Repo from "@/services/api/util/auth-repo-local-storage"
import errorsMixin from '@/mixins/errors.mixin'
import permsMixin from "@/mixins/perms.mixin"
import CandidatesCount from "./core/models/candidatesCountModel"
import CRMauth from "@/services/CRMinitAuth"
import Log from "./components/CandidatesLog.vue"

export default {
  data: () => ({
    svc: null,
    logs: null,
    logsShowing: false,
    logActive: true,
    showingFilters: false,
    candidatesCount: new CandidatesCount(),
  }),
  inject: ['perms'],

  mixins: [errorsMixin, PaginationMixin, permsMixin],

  computed: {
    ...mapGetters({
      currentUser: 'user/current',
      cities: 'crmCourseCities/items',
    }),
    courseLocations() {
      let locations = getMultipleQueryValue(this.$route.query[FILTERS_ARGS.CITY_COURSE])
      if(!locations.length || !this.cities) return false
      return locations.map(cityID => {
        let sameCity = this.cities.find(city => +city.ID === +cityID)
        if(!sameCity) return
        return sameCity.name
      })
    }
  },

  created() {
    this.init()
  },

  async mounted() {
    this.loadLabels()
  },

  methods: {
    ...mapActions({
      loadLabels: 'labels/list'
    }),
    init() {
      this.svc = new CandidatesSvc()
    },

    async goToLocation(query) {
      let needToUpdateList = false
      if(this.$route.name === this.$ROUTER_NAMES.CANDIDATES) needToUpdateList = true
      this.$router.push({name: this.$ROUTER_NAMES.CANDIDATES, query: query})
      if(needToUpdateList) this.loadList()
    },

    loadList() {
      this.$refs.list.loadList({})
    },

    getTitleLocation() {
      let locations = getMultipleQueryValue(this.$route.query[FILTERS_ARGS.CITY_COURSE])
      if(!locations.length) return false
      return locations.reduce( (acc, city) => acc + ', ' + city)
    },

    setCandidatesCount(counts) {
      this.candidatesCount.set(counts)
    }
  },

  provide: function() {
    return {
      getDefaultPagination: this.getDefaultPagination,
      svc: () => this.svc,
      closeExpanded: this.closeExpanded
    }
  },

  components: {
    create: () => import('./components/candidates/CandidateCreate.vue'),
    log: Log,
    filters: Filters
  }
}
</script>

<style lang="scss" scoped>
.filters-open::v-deep {
  .candidate__actions {
    @media(min-width: 768px) {
      width: auto;
      right: 30%;
    }
  }
}
.btn-floating {
  transition: all .3s ease;
  transform: scale(1)
}

.filters-hide {
  transform: scale(0)
}

.relative {
  position: relative;
}
.separator-col-right::v-deep  {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.reservation {
    margin-top: 15px;
    border: 1px solid rgba(0, 0, 0, 0.24);
    padding: 0 15px;
    border-radius: 6px;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
